import React, { useState, useEffect, useRef } from "react";
import LeftImg from "assets/icons/left.svg";
import RightImg from "assets/icons/right.svg";
import "./style.scss";

type Props = {
	pageIndex: number;
	pageCount: number;
	setCurrentPage: (val: number) => void;
};

export const Pagination: React.FC<Props> = ({
	pageIndex,
	pageCount,
	setCurrentPage,
}) => {
	let timer;
	const nameInput = useRef<HTMLInputElement>(null);
	const [pageNumber, setPageNumber] = useState(pageIndex);

	const onInputChange = (e: any) => {
		const value = e.target.value;

		setPageNumber(value);

		if (pageCount > 0 && pageIndex > 0 && parseInt(value) <= pageCount && value != "") {
			setCurrentPage(parseInt(value));
		}
		// clearTimeout(timer);
		// timer = setTimeout(function() {
		//     console.log('User finished typing !!');
		// 		if(value != "") {
		// 			setCurrentPage(value);
		// 		}
		// }, 500);
	}

	const onInputKeyUp = (e: any) => {
		const { key } = e;
		clearInterval(timer);
		timer = setTimeout(function () {
			let value = pageIndex + "";
			if (key === "Backspace") {
				if (value.length > 1) {
					value = value.slice(0, value.length - 1);
				}
			} else {
				value = value + key;
			}
			if (value != "") {
				setCurrentPage(parseInt(value));
			}
			console.log(value);
		}, 500);
	}

	useEffect(() => {
		setPageNumber(pageIndex);
	}, [pageIndex]);

	return (
		<div className="pagination-container">
			<div style={{ flexGrow: 1 }}></div>
			<span>Page</span>
			<input
				type="number"
				value={pageNumber}
				ref={nameInput}
				min={1}
				max={pageCount}
				style={{ width: "60px" }}
				// onKeyUp={(e: any) => onInputKeyUp(e)}
				onChange={onInputChange}
			></input>
			<span>of {pageCount}</span>
			<img
				src={LeftImg}
				alt="left-arrow"
				onClick={() => {
					if (pageIndex > 1) {
						setCurrentPage(pageIndex - 1);
						setPageNumber(pageIndex - 1);
					}
				}}
			/>
			<img
				src={RightImg}
				alt="right-arrow"
				onClick={() => {
					if (pageIndex < pageCount) {
						setCurrentPage(pageIndex + 1);
						setPageNumber(pageIndex + 1);
					}
				}}
			/>
		</div>
	);
};
